import styled from 'styled-components';
type DataProps = {
  width: string;
  gridArea?: string;
};

export const Data = styled.div<DataProps>`
  width: ${(props) => props.width};
  font-weight: bold;
  text-align: left;
  margin-right: 20px;
  &.checkbox_table {
    margin-right: 20px;
  }
  .checkbox_text{
    display: none;
  }
  @media screen and (max-width: 960px) {
    .checkbox_text{
      display: flex;
    }
    &.checkbox_all{
      margin-right: 0px;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 5px
    }
    &.checkbox_table {
      display: flex;
    }
    &.checkbox_table {
      display: none;
    }
    &.hidden {
      display: none;
    }
    &#recipes-executions {
      width: auto;
      grid-area: ${(props) => props.gridArea};
    }
  }
`;

export const Tooltip = styled.div`
  visibility: hidden;
  background-color: white;
  color: #004992;
  text-align: center;
  font-family: Roboto, sans-serif;
  font-weight: bold;
  font-size: 12px;
  border-radius: 5px;
  padding: 5px 10px;
  position: absolute;
  top: -20%;
  left: 130%;
  opacity: 0;
  transition: opacity 0.3s;
  white-space: nowrap;
  box-shadow: 0 0 0.7em ${props => props.theme.colors.boxShadow};
  border: 1px solid #004992;
 
  &::after {
    content: "";
    position: absolute;
    top: 30%;
    right: 0;
  }
`;

export const DataDiv = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;

  &.showTooltip {
    position: relative;
    display: inline-block;
    overflow: visible;
  
    &:hover > ${Tooltip} {
      visibility: visible;
      opacity: 1;
    }
  }
`;

export const THeader = styled.div`
  padding: 8px 20px;
  display: flex;
  @media screen and (max-width: 960px) {
    display: none;

    &.serialNumbers-table{
      display: flex;
      justify-content: flex-end;
      padding: 8px 14px;
    }

    &.checkbox_table {
      display: flex;
    }

    &.show_header_mobile {
      display: flex;
    }

    &#recipes-executions {
      display: grid;
      grid-template-columns: 3fr 2fr 1fr 2fr 1fr;
      grid-template-rows: 20px;
      grid-template-areas:
        'title data1 data2 data3 data4'
    }
  }
`;
